import { Box, ChakraProvider, Flex, Spacer } from "@chakra-ui/react";
import React from "react";

export default function Test() {
    return (
        <ChakraProvider>
            <Dashboard />
        </ChakraProvider>
    )
}

const Dashboard = () => {
    return (
        <Flex>
            <Sidebar />
            <Spacer />
            <Content />
        </Flex>
    )
}

const Sidebar = () => {
    return (
        <Box
            as="nav"
            h="100vh"
            w="16%"
            bg="orange.500"
            color="white"
            p="4"
            boxShadow="md"
        >
            {/* Add your sidebar content here */}
            Sidebar Content
        </Box>
    )
}

const Content = () => {
    return (
        <Box p="4" flex="1">
            {/* Add your content here */}
            Content Area
        </Box>
    )
}